import { faComment, faHouse } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import VoxelAlert from '../../components/voxel/Alert/VoxelAlert';
import VoxelButton from '../../components/voxel/Buttons/VoxelButton';
import VoxelButtonGrid from '../../components/voxel/Buttons/VoxelButtonGrid';
import { useSleek } from '../sleekContext/useSleek';

export interface NotFoundErrorPageProps {}

const NotFoundErrorPage: React.FC<NotFoundErrorPageProps> = ({}) => {
  const sleek = useSleek();
  return (
    <div className="fixed h-1/2 w-full flex flex-col items-center justify-center content-center p-12">
      <VoxelAlert title="Page not found (404)" widthClass="w-[396]">
        Page not found. Contact the Voxel team if the error persists.
      </VoxelAlert>
      <div className="h-8" />
      <VoxelButtonGrid>
        <VoxelButton
          title="Home"
          startIcon={<FontAwesomeIcon icon={faHouse} />}
          onClick={() => (window.location.href = window.location.origin)}
        />
        <VoxelButton
          title="Feedback"
          startIcon={<FontAwesomeIcon icon={faComment} />}
          onClick={() => sleek.openFeedback()}
        />
      </VoxelButtonGrid>
    </div>
  );
};

export default NotFoundErrorPage;
